<template>
  <aside v-if="visible" class="ae-overlay" aria-label="Agent">
    <AgentConversation
      ref="conversation"
      :entry="entry"
      :context="context"
      :storage-key="storageKey"
      compact
      @open-full="openFull"
      @close="overlay.open = false"
      @apply-proposal="applyProposal"
      @save-sheet="saveSheet"
    />
  </aside>
</template>

<script>
import AgentConversation from './AgentConversation.vue';
import './agent.css';
import { sessionEntry, agentOverlay } from '@/services/agentSessionController';
import { notifyWorkflowSaved, requestCanvasApply, requestCanvasSheet } from '@/services/canvasContext';
import { canUseAgentPopup } from '@/utils/agentAccess';
import agentPageContext from '@/mixins/agentPageContext';

export default {
  name: 'AgentOverlay',
  components: { AgentConversation },
  mixins: [agentPageContext],
  data() {
    return { overlay: agentOverlay };
  },
  computed: {
    onAgentPage() {
      return this.$route.name === 'Agent';
    },
    pageContextPaused() {
      return this.onAgentPage;
    },
    visible() {
      return this.overlay.open && canUseAgentPopup(this.$store.state.auth.current_user) && !this.onAgentPage;
    },
    scope() {
      return `${this.$store.state.tenant.current_tenant_slug || ''}:${this.$store.state.auth.current_user?.id || ''}`;
    },
    entry() {
      return sessionEntry(`${this.scope}:overlay`);
    },
    storageKey() {
      return `agent-overlay:${this.scope}`;
    },
    context() {
      const r = this.$route;
      return {
        metricId: r.params.metricId || r.query.metric || null,
        studyId: r.params.studyId || r.query.study || null,
        s3Key: r.query.file || '',
        schemaId: r.query.schema || null,
      };
    },
    savedWorkflows() {
      return this.entry.state.artifacts
        .filter((a) => a.kind === 'data_workflow')
        .map((a) => a.id)
        .join(',');
    },
  },
  watch: {
    visible: { immediate: true, handler(on) { this.bindView(on); } },
    entry(next, prev) {
      if (prev && prev.view === this) prev.view = null;
      this.bindView(this.visible);
    },
    onAgentPage(on) {
      if (on) this.overlay.open = false;
    },
    savedWorkflows(ids, before) {
      if (ids && ids !== before) notifyWorkflowSaved();
    },
  },
  beforeUnmount() {
    if (this.entry.view === this) this.entry.view = null;
  },
  methods: {
    bindView(on) {
      if (on) this.entry.view = this;
      else if (this.entry.view === this) this.entry.view = null;
    },
    applyProposal(proposal) {
      requestCanvasApply(proposal);
    },
    saveSheet(sheet) {
      requestCanvasSheet(sheet);
    },
    openFull(sessionId) {
      const { href } = this.$router.resolve({ name: 'Agent', params: sessionId ? { sessionId } : {} });
      window.open(href, '_blank', 'noopener');
    },
  },
};
</script>
